




























































































import Vue from "vue";
import { Dispatcher, Committer } from "vuex-type-helper";
import Multiselect from "vue-multiselect";
import Checkbox from "./Checkbox.vue";
import ButtonAction from "./ButtonAction.vue";
import axios, { AxiosPromise } from "axios";
import get from "lodash-es/get";
import debounce from "lodash-es/debounce";
import { ApplicationActions } from "../store";
import { Autorisatie } from "../Autorisatie";
import { Options } from "jwt-decode";
import { Guid } from "guid-typescript";
import { EventBus } from "../lib/EventBus";
import { PivotDefinitieType } from "../PublicEnums";

interface TemplateData {
  Id: string;
  Omschrijving: string;
  DefinitieType: number;
  Shared: boolean;
  UserID: string;
  FilterSettings: string;
  PivotSettings1: string;
}

interface OptionsData {
  Group: string;
  Data: TemplateData[];
}

interface PivotDefinitiesViewModel {
  Mine: TemplateData[];
  Others: TemplateData[];
}

interface Button {
  ShowMethod: string;
}

enum Action {
  Default,
  Remove,
  Rename,
  SaveAs
}

export default Vue.extend({
  name: "OrdersPivotTemplateSelection",

  props: {
    pivotDefinitieType: {
      type: Number,
      required: true,
      validator: (value: Number): boolean => {
        return value === PivotDefinitieType.Leads || value === PivotDefinitieType.Orders;
      },
    }
  },

  components: {
    Multiselect,
    Checkbox,
    ButtonAction
  },

  data() {
    const newTemplate = {
      Id: Guid.createEmpty().toString(),
      Omschrijving: `${this.$i18n.t("newtemplate")}`,
      DefinitieType: this.pivotDefinitieType,
      Shared: false,
      UserID: this.$store.getters.userId,
      FilterSettings: "{}",
      PivotSettings1: "{}"
    } as TemplateData;

    const first = 3;
    const last = 4;

    const templateListUrlOrders =
      "api/backend/v1/dashboard/orders/grid/templates";
    const templateListUrlLeads =
      "api/backend/v1/dashboard/leads/grid/templates";

    return {
      emptyGuid: Guid.createEmpty().toString(),
      templates: {
        Mine: [] as TemplateData[],
        Others: [] as TemplateData[]
      } as PivotDefinitiesViewModel,
      newTemplate: newTemplate as TemplateData,
      selectedTemplateData: newTemplate as TemplateData,
      getDataDebounced: null as null | Function,
      action: Action.Default as Action,
      newTemplateName: "" as string,
      isLoading: false as boolean,
      first: first, // Do not modify this value (no constant option available)
      last: last, // Do not modify this value (no constant option available)
      confirmPos: last,
      cancelPos: first,
      templateUrl: "" as string,
      templatesUrl: "" as string,
      originalSharedValue: false as boolean,
      newSharedValue: false as boolean
    };
  },

  created() {
    this.getDataDebounced = debounce(() => {
      this.getTemplateList();
    }, 500);
  },

  mounted() {
    this.selectedTemplateData = this.fillOptionsData[0].Data[0];
    this.getTemplateUrls();
    this.getTemplateList();
  },

  computed: {
    selectedShared: {
      get: function(): boolean {
        return (
          !!this.selectedTemplateData &&
          this.selectedTemplateData.Shared &&
          this.hasAutorisatie(Autorisatie.PivotGridSettingsPublic)
        );
      },
      set: function(newValue: boolean) {
        if (!!this.selectedTemplateData)
          this.selectedTemplateData.Shared = newValue;
      }
    },

    checkDisabled(): boolean {
      return !(
        this.hasAutorisatie(Autorisatie.PivotGridSettingsPublic) &&
        !!this.selectedTemplateData
      );
    },

    checkMainComponentsVisible(): boolean {
      return (
        this.action === Action.Default &&
        this.selectedTemplateData &&
        this.$store.getters.userId === this.selectedTemplateData.UserID &&
        this.selectedTemplateData.Id !== this.emptyGuid
      );
    },

    checkConfirmComponentVisible(): boolean {
      return this.action !== Action.Default;
    },

    getSaveButtonText(): string {
      return this.selectedTemplateData &&
        (this.$store.getters.userId !== this.selectedTemplateData.UserID ||
          this.selectedTemplateData.Id === this.emptyGuid)
        ? this.$t("saveastemplate").toString()
        : this.$t("savetemplate").toString();
    },

    getConfirmButtonText(): string {
      switch (this.action) {
        case Action.Remove:
          return this.$t("removetemplate").toString();
          break;
        case Action.Rename:
        case Action.SaveAs:
          return this.$t("savetemplate").toString();
          break;
        default:
          return this.$t("confirm").toString();
      }
    },

    fillOptionsData(): OptionsData[] {
      this.templates.Mine = this.templates.Mine.sort((a, b) => {
        return a.Omschrijving.toLowerCase() < b.Omschrijving.toLowerCase()
          ? -1
          : 1;
      });
      this.templates.Others = this.templates.Others.sort((a, b) => {
        return a.Omschrijving.toLowerCase() < b.Omschrijving.toLowerCase()
          ? -1
          : 1;
      });

      this.newTemplate.Omschrijving = `${this.$i18n.t("newtemplate")}`;

      const options = [
        {
          Group: "",
          Data: [this.newTemplate] as TemplateData[]
        },
        {
          Group: this.$t("ownedprivate").toString(),
          Data: this.templates.Mine.filter(template => {
            return !template.Shared;
          })
        },
        {
          Group: this.$t("ownedshared").toString(),
          Data: this.templates.Mine.filter(template => {
            return template.Shared;
          })
        },
        {
          Group: this.$t("notownedshared").toString(),
          Data: this.templates.Others
        }
      ] as OptionsData[];

      return options;
    },

    allTemplatesFromList(): TemplateData[] {
      return this.templates.Mine.concat(
        this.templates.Others,
        this.newTemplate
      );
    }
  },

  methods: {
    getTemplateUrls(): void {
      switch (this.pivotDefinitieType) {
        case PivotDefinitieType.Leads:
          this.templateUrl = "api/backend/v1/dashboard/leads/grid/template";
          this.templatesUrl = "api/backend/v1/dashboard/leads/grid/templates";
          break;
        case PivotDefinitieType.Orders:
          this.templateUrl = "api/backend/v1/dashboard/orders/grid/template";
          this.templatesUrl = "api/backend/v1/dashboard/orders/grid/templates";
          break;
        default:
      }
    },

    hasAutorisatie(autorisatie: number): boolean {
      return this.$store.getters.hasAutorisatie(autorisatie);
    },

    getTemplateList(): void {
      this.isLoading = true;
      axios
        .get(this.templatesUrl)
        .then(response => {
          if (!!response && !!response.data) {
            this.templates = response.data as PivotDefinitiesViewModel;
          }
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          EventBus.$emit("add-toastr", {
            text: this.$t("templategetlisterror").toString(),
            type: "error"
          });
        });
    },

    templateSelected(selectedOption: TemplateData, id: any): void {
      this.$emit(
        "select",
        selectedOption.FilterSettings,
        selectedOption.PivotSettings1
      );
      this.originalSharedValue = selectedOption.Shared;
    },

    onRenameButtonClicked(): void {
      if (
        this.allTemplatesFromList.findIndex(
          t => t.Id === this.selectedTemplateData.Id && this.originalSharedValue
        ) > -1
      ) {
        EventBus.$emit("add-toastr", {
          text: this.$t("templaterenameshared").toString(),
          type: "warning"
        });
      }

      this.newTemplateName = this.selectedTemplateData.Omschrijving;
      this.action = Action.Rename;
      this.cancelPos = this.last;
      this.confirmPos = this.first;
    },

    onRemoveButtonClicked(): void {
      if (
        !this.selectedTemplateData ||
        this.selectedTemplateData.Id === this.emptyGuid
      ) {
        return;
      }

      EventBus.$emit("add-toastr", {
        text: this.$t(
          this.originalSharedValue
            ? "templateconfirmremoveshared"
            : "templateconfirmremove"
        ).toString(),
        type: "warning"
      });

      this.newTemplateName = this.selectedTemplateData.Omschrijving;
      this.action = Action.Remove;
      this.cancelPos = this.first;
      this.confirmPos = this.last;
    },

    processRemove(): void {
      axios
        .delete(this.templateUrl + "/" + this.selectedTemplateData.Id)
        .then(response => {
          this.selectedTemplateData = this.newTemplate;
          this.getTemplateList();

          EventBus.$emit("add-toastr", {
            text: this.$t("templateremovesuccess").toString(),
            type: "success"
          });

          this.resetAction();
        })
        .catch(response => {
          EventBus.$emit("add-toastr", {
            text: this.$t("templateremoveerror").toString(),
            type: "error"
          });
        });
    },

    onSaveButtonClicked(): void {
      let originalTemplate = this.allTemplatesFromList.find(
        t => t.Id === this.selectedTemplateData.Id
      );

      if (!originalTemplate) return;

      if (
        originalTemplate.UserID === this.$store.getters.userId &&
        originalTemplate.Id !== this.emptyGuid &&
        !originalTemplate.Shared
      ) {
        // trigger event in parent to retrieve filter - and pivot settings back here in 'processSave'
        this.$emit("saveClicked");
        return;
      }

      if (originalTemplate!.Id !== this.emptyGuid) {
        this.newTemplateName = this.selectedTemplateData.Omschrijving;
      }

      if (
        originalTemplate!.UserID === this.$store.getters.userId &&
        originalTemplate.Id !== this.emptyGuid &&
        this.originalSharedValue
      ) {
        EventBus.$emit("add-toastr", {
          text: this.$t("templatesaveshared").toString(),
          type: "warning"
        });
      }

      this.action = Action.SaveAs;
      this.confirmPos = this.first;
      this.cancelPos = this.last;
    },

    processSave(filterSettings: string, pivotSettings: string): void {
      let template = {
        Id:
          this.selectedTemplateData.Id === this.emptyGuid ||
          this.selectedTemplateData.UserID !== this.$store.getters.userId
            ? Guid.create().toString()
            : this.selectedTemplateData.Id,
        Omschrijving:
          this.action === Action.Default
            ? this.selectedTemplateData.Omschrijving
            : this.newTemplateName,
        DefinitieType: this.pivotDefinitieType,
        Shared: this.action === Action.Rename
          ? this.originalSharedValue
          : this.selectedShared,
        UserID: this.$store.getters.userId,
        FilterSettings: filterSettings,
        PivotSettings1: pivotSettings
      } as TemplateData;

      this.newSharedValue = this.selectedShared;

      axios
        .post(this.templateUrl, template, {
          headers: { "Content-Type": "application/json" }
        })
        .then(response => {
          this.getTemplateList();

          this.selectedTemplateData = template;
          this.originalSharedValue = template.Shared;

          EventBus.$emit("add-toastr", {
            text: this.action === Action.Rename
              ? this.$t("templaterenamesuccess").toString()
              : this.$t("templatesavesuccess").toString(),
            type: "success"
          });

          this.resetAction();
          this.selectedShared = this.newSharedValue;
        })
        .catch(response => {
          EventBus.$emit("add-toastr", {
            text: this.action === Action.Rename
              ? this.$t("templaterenameerror").toString()
              : this.$t("templatesaveerror").toString(),
            type: "error"
          });

          this.selectedShared = this.newSharedValue;
        });
    },

    onConfirmButtonClicked(): void {
      switch (this.action) {
        case Action.Remove:
          this.processRemove();
          break;
        case Action.Rename:
          this.processSave(this.selectedTemplateData.FilterSettings, this.selectedTemplateData.PivotSettings1);
          break;
        case Action.SaveAs:
          let msg = "";

          if (this.newTemplateName === "") {
            msg = this.$t("savename").toString();
          }
          if (
            this.allTemplatesFromList.findIndex(
              t => t.Omschrijving === this.newTemplateName
            ) > -1 &&
            this.allTemplatesFromList.findIndex(
              t =>
                t.Id === this.selectedTemplateData.Id &&
                t.UserID !== this.$store.getters.userId
            ) > -1
          ) {
            msg = this.$t("templatesavenameexists").toString();
          }

          if (msg !== "") {
            EventBus.$emit("add-toastr", {
              text: msg,
              type: "error"
            });
          } else {
            // trigger event in parent to retrieve filter - and pivot settings back here in 'processSave'
            this.$emit("saveClicked");
          }
          break;
      }
    },

    onCancelButtonClicked(): void {
      this.resetAction();
    },

    resetAction(): void {
      this.newTemplateName = "";
      this.action = Action.Default;
      this.cancelPos = this.first;
      this.confirmPos = this.last;
    }
  }
});
